import { render } from "./IndexContent.vue?vue&type=template&id=7c24cd01"
import script from "./IndexContent.vue?vue&type=script&lang=js"
export * from "./IndexContent.vue?vue&type=script&lang=js"
script.render = render

export default script